// Otherwise the link stays a valid login until it expires
export const discardAisTicket = (token: string): void => {
  fetch(`${window._env_.KEYCLOAK_URL}/realms/medcom/ais-login/discard`, {
    method: 'POST',
    mode: 'no-cors',
    body: new URLSearchParams({ token }),
  }).catch(() => undefined);
};
